module.exports = __webpack_public_path__ + "img/caselist32.5a513445.jpg";